import React from "react";
import { Application } from "../../app/stores/applications-slice";
import { Chrome, FileText, Folder, Settings, Youtube, AlertCircle } from "lucide-react";

interface DesktopShortcutProps {
    application: Application;
    onDoubleClick?: () => void;
}

const getIconComponent = (iconType: string, iconColor: string) => {
    const className = `w-10 h-10 ${iconColor}`;
    switch (iconType) {
        case "Folder":
            return <Folder className="w-10 h-10 text-orange-500" />;
        case "Settings":
            return <Settings className={className} />;
        case "Chrome":
            return <Chrome className={`${className} text-red-500`} />;
        case "FileText":
            return <FileText className={`${className} text-gray-500`} />;
        case "Youtube":
            return <Youtube className={`${className} text-red-500`} />;
        case "AlertCircle":
            return <AlertCircle className={className} />;
        default:
            return <Folder className="w-10 h-10 text-orange-500" />;
    }
};

export const DesktopShortcut: React.FC<DesktopShortcutProps> = ({ application, onDoubleClick }) => {
    const icon = getIconComponent(application.iconData.type, application.iconData.color);

    return (
        <div
            className="desktop-shortcut  rounded-lg transition-colors"
            onDoubleClick={onDoubleClick}
            style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                padding: "8px",
                cursor: "pointer",
                userSelect: "none",
                width: "80px",
                textAlign: "center",
            }}>
            <div
                className="icon"
                style={{
                    width: "48px",
                    height: "48px",
                    marginBottom: "4px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }}>
                {icon}
            </div>
            <span
                className="name"
                style={{
                    fontSize: "12px",
                    color: "#ffffff",
                    wordBreak: "break-word",
                    textShadow: "0 1px 2px rgba(0,0,0,0.5)",
                    display: "inline-block",
                    width: "100%",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                }}>
                {application.name}
            </span>
        </div>
    );
};
